import { render } from "./DonateCTA.vue?vue&type=template&id=bcecb530&scoped=true"
import script from "./DonateCTA.vue?vue&type=script&lang=js"
export * from "./DonateCTA.vue?vue&type=script&lang=js"

import "./DonateCTA.vue?vue&type=style&index=0&id=bcecb530&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcecb530"]])

export default __exports__